import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartPie = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 0 1 6.833 12.162.77.77 0 0 1-.062.202l-.054.097a.747.747 0 0 1-.234.226A8 8 0 1 1 8 0zm-.75 1.543A6.501 6.501 0 1 0 12.962 12.2L7.586 8.647l-.027-.019a.75.75 0 0 1-.044-.034l-.013-.012-.004-.003-.02-.018a.746.746 0 0 1-.017-.017l-.017-.02a.75.75 0 0 1-.024-.027l-.007-.008a.744.744 0 0 1-.1-.168l-.005-.01a.764.764 0 0 1-.007-.018l-.011-.03a.75.75 0 0 1-.019-.063l.03.093A.755.755 0 0 1 7.25 8zm7.047 4.84L9.624 8.195l4.168 2.757c.42-.82.67-1.742.704-2.719L14.5 8c0-.558-.07-1.1-.203-1.617zm-2.102-3.348L9.924 6.47l3.834-1.488a6.527 6.527 0 0 0-1.563-1.947zM8.75 1.543v3.983l2.197-3.321a6.456 6.456 0 0 0-2.197-.662z" />
    </g>
  );
};

export default withIcon(IconChartPie);
